import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import { grey } from '@mui/material/colors';

import { Column } from '../types';

interface Props<Data extends Record<string, any>, Context extends any = any> {
  columns: Column<Data, Context>[];
  maxHeight?: string;
}

export const TableContainer = <Data extends Record<string, any>, Context extends any = any>({
  children,
  columns,
  maxHeight,
}: PropsWithChildren<Props<Data, Context>>) => (
  <Box
    sx={{
      display: 'grid',
      overflowY: 'auto',
      overflowX: 'auto',
      position: 'relative',
      borderRadius: '0.5rem',
      gridTemplateRows: 'auto 1fr',
      outline: `1px solid ${grey['300']}`,
      minHeight: 0,
      ...(maxHeight && { maxHeight }),

      '& .listing-header': {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: grey['300'],

        '& .listing-cell': {
          borderLeft: `1px solid ${grey['100']}`,
          borderRight: `1px solid ${grey['100']}`,
        },
      },

      '& .listing-body': {},

      '& .listing-footer': {},

      '& .listing-pagination': {
        position: 'sticky',
        bottom: 0,
        zIndex: 2,
        backgroundColor: '#fff',
        width: '100%',
        padding: '0.5rem 1rem',
        outline: `1px solid ${grey['300']}`,
      },

      '& .listing-section': {
        display: 'grid',
        gridTemplateColumns: columns.map(column => column.width || '1fr').join(' '),
      },

      '& .listing-row-detail': {
        width: '100%',
        padding: '0.75rem 1rem',
        backgroundColor: grey['50'],
        borderBottom: `1px solid ${grey['300']}`,
      },

      '& .listing-cell': {
        gap: '0.5rem',
        display: 'flex',
        minHeight: '3.5rem',
        alignItems: 'center',
        padding: '0.5rem 1rem',
        border: `1px solid ${grey['300']}`,
      },

      '& .listing-loading': {
        top: 0,
        left: 0,
        height: 2,
        zIndex: 3,
        width: '100%',
        position: 'absolute',
      },
    }}
  >
    {children}
  </Box>
);
